import { Injectable } from '@angular/core';
import { HttpErrorResponse, HttpStatusCode } from '@angular/common/http';
import { ErrorMessageInterceptor } from '@capturum/complete';

@Injectable({ providedIn: 'root' })
export class CustomErrorMessageInterceptor extends ErrorMessageInterceptor {
    public exceptionUrls(err: HttpErrorResponse): boolean {
        if (err.status === HttpStatusCode.UnprocessableEntity && err.url?.includes('/transition-document/') && err.url?.endsWith('/answers')) {
            return false;
        }

        if (err.status === HttpStatusCode.Conflict && err.url?.includes('/transition-document/') && err.url?.endsWith('/reopen')) {
            return false;
        }

        return super.exceptionUrls(err);
    }
}
